/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */

import React, { useCallback, useEffect, useRef, useState } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import {debounce} from 'lodash'
import  { GeneralMap } from 'components/map/Map'
import './index.less'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
import CameraFinder from 'components/image-upload/CameraFinder'
import DeviceDetail from 'components/image-upload/DeviceDetail'
import Controls from '../../components/image-upload/Controls'
import GPSTracker from '../../components/map/gps-tracker'
import Cameras from '../../components/map/Cameras'
import Traces from '../../components/image-upload/Traces'
import { message, Modal } from 'antd'
import { withRouter } from 'react-router-dom'
import { DOWNLOAD_TASK_TYPE } from '../../constants'
import { DeviceType } from '../../constants/device'


const ImageUpload = props => {
  const [expand, setExpand] = useState(true)
  const timeTaskID = useRef(null)
  const leftMenuRef = useRef(null)

  const { cameraFinderState, currentCity, boundingBox, hoveredCamera, uploadingCamera} = useSelector(({cameraFinder, city,map, cameras}) => ({
    cameraFinderState : cameraFinder,
    currentCity: city.current,
    boundingBox: map.boundingBox,
    hoveredCamera: cameras.hoveredCamera,
    uploadingCamera: cameras.uploadingCamera
  }))
  const {
    map:mapAction,
    cameras: {fetchCameras,updateUploadingCamera, updateHoveredCamera,clear: clearCamera},
    cameraFinder:{setFilter, setLoading, setExpanded, clear: clearCameraFinder},
    download:{updateEditingPreTask,createDownloadTask, changeTaskType},
    city:{onCityChange: changeCity}
  } = useDispatch()
  useEffect(() =>{
    mapAction.setDefaultCenter()
    return()=>{
      clearCamera()
      clearCameraFinder()
    }
  },[])

  useEffect(() =>{
    const {deviceID,deviceType,...rest} = cameraFinderState.filter
    debounceHandleViewportChanged({boundingBox,cityID: currentCity.id,deviceID,deviceType,...rest})
  },[boundingBox.toString()])
  useEffect(() =>{
    const {deviceID, deviceType,...rest} = cameraFinderState.filter
    const filters = {boundingBox,cityID: currentCity.id,deviceID,deviceType,...rest}
    timeTaskID.current = setInterval(()=>{
      if(uploadingCamera !== null) return
      handleCameraFilter(filters)
    }, 1000 * 60)
    return ()=>{
      clearInterval(timeTaskID.current)
    }
  })

  const initPageByHistoryState = async ()=>{
    const historyState = props.location.state || {}
    const {cityID, taskType,longitude,latitude,deviceID} = historyState
    if(cityID !== undefined){
      await changeCity(cityID)
      await changeTaskType(taskType || DOWNLOAD_TASK_TYPE.DEVICE)
    }
    if(taskType === DOWNLOAD_TASK_TYPE.DEVICE){
      setFilter({deviceID})
      mapAction.setCenter([longitude,latitude])
    }
    if(deviceID === undefined){
      mapAction.setDefaultCenter()
    }
  }

  const handleExpandIconClick = () => {
    setExpand(!expand)
  }
 const  handleTransitionEnd = (e)=>{
    e.persist()
    if(e.target === leftMenuRef.current && e.propertyName === 'transform'){
      console.log('transitionend',expand, e.propertyName, e)
      setExpanded(expand)
    }
 }
  const handleMapClick = (e) => {
    if(hoveredCamera){
      updateHoveredCamera(null)
    }
  }
  const handleCameraFilter = async (filters) => {
    const {boundingBox,cityID,deviceID,status,deviceType,onlineStatus,sortBy,order} = filters || {}
    console.log('===filters===',filters)
    const query = {
      cityID,
      bbox: boundingBox,
      page: 1,
      pageSize: 10000,
      status: `${status}` === '-1' ? undefined : status,
      onlineStatus: `${onlineStatus}` === '-1' ? undefined: onlineStatus,
      deviceType : deviceType !== '-1' ? deviceType : undefined,
      keyword: deviceID || undefined,
      sortBy,
      order
    }
    if (deviceID) {
      query.bbox = undefined
    }
    if(deviceType === DeviceType.Lite360Master){
      query.deviceType = [DeviceType.Lite360Slave,DeviceType.Lite360Master]
    }
    await fetchCameras(query)
  }

  const handleUpload = () => {

    Modal.confirm({
      title: 'Are you sure you want to upload images from camera?',
      content: '',
      onOk: () => {
        return createDownloadTask()
          .then(() => {
            updateUploadingCamera(null)
            Modal.success({
              title: 'Submit Success',
              content: 'You can check the process in Upload Pending List',
              onOk: () => {
                const {history} = props
                history.push('/uploadqueue')
              },
              okText: 'Go to Upload Pending List',
              cancelText: 'Back',
              maskClosable: true
            })
          })
          .catch(err => {
            message.error(err.toString())
          })
      }
    })
  }

  const handleCameraFinder = ({type, payload})=>{
    const filter = cameraFinderState.filter
      switch(type){
        case 'filter':
          setFilter(payload)
          handleCameraFilter({...filter,...payload,boundingBox, cityID: currentCity.id})
          break
        case 'upload':
          updateEditingPreTask(payload)
          handleUpload()
          break
        default:
          break
      }
  }
  const handleMapLoaded = async (map,filters)=>{
    await initPageByHistoryState()
    await handleCameraFilter({...filters, cityID: currentCity.id})
  }
  const handleViewportChanged = (filters)=>{
    handleCameraFilter(filters)
  }
  const debounceHandleViewportChanged  = useCallback(debounce(handleViewportChanged,1000),[])
  const mapContainerStyle = { height: 'calc(100vh - 40px)' }
  return (
    <div className={'imagery-upload'}>
      <div className={'left' + ' ' + (expand ? 'show' : '')} ref={leftMenuRef} onTransitionEnd={handleTransitionEnd}>
        <div onClick={handleExpandIconClick} className='expand-icon'>
          {expand ? <CaretLeftOutlined /> : <CaretRightOutlined />}
        </div>
        {expand ? <div style={{ margin: '14px', fontSize: '16px', marginBottom: '20px' }}>{'KartaCam Devices'}</div> : null}
        {expand ? <CameraFinder onChange={handleCameraFinder} defaultValue={cameraFinderState.filter.deviceID}/>: null}

      </div>
      <div className={'right'}>
        <GeneralMap
          containerStyle={mapContainerStyle}
          onViewportChanged={null}
          // onViewportChanged={debounceHandleViewportChanged}
          onStyleLoad={handleMapLoaded}
          onMapClick={handleMapClick}
        >
          <Cameras/>
          <Traces/>
          <Controls/>
        </GeneralMap>
      </div>
      <DeviceDetail/>
      <GPSTracker style={{position:'absolute',top: '20px', right:'20px'}}/>
    </div>
  )
}
export default withRouter(ImageUpload)
